import React, { Component } from "react"

/* Components */
import { Layout, Input } from "../../components"

/* REST API */
import { roles, create } from "../../api/Admin"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* Swal */
import Swal from "sweetalert2"

/* Switch */
import Switch from "react-switch"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"


/* Page Admin Create */
class AdminCreate extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            name: "",
            email: "",
            extendedAccess: 0,
            team: "",
            password: "",
            roleID: 0,
            waiting: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Roles */
    load = (reload = false) => {

        if (reload) {
            this.setState({ status: "loading" })
        }

        roles().then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })

    }

    /* Save action */
    save = () => {

        const { name, email, password, roleID, extendedAccess, team } = this.state
        const { navigate, admin } = this.props

        if (name === "" || name === null || name === undefined) {
            this._name.error(t("admin.error.emptyName"))
            return
        }

        if (email === "" || email === null || email === undefined) {
            this._email.error(t("admin.error.emptyEmail"))
            return
        }

        if (extendedAccess && team.length === 0) {
            this._command.error(t("admin.error.emptyTeam"))
            return
        }


        if (/\S+@\S+\.\S+/.test(email) === false) {
            this._email.error(t("admin.error.invalidEmail"))
            return
        }

        if (password === "" || password === null || password === undefined) {
            this._password.error(t("admin.error.emptyPassword"))
            return
        }

        if (password.length < 8) {
            this._password.error(t("admin.error.shortPassword"))
            return
        }

        if (roleID === 0) {
            Swal.fire(utils.notification(t("admin.error.selectRole"), "error"))
            return
        }

        this.setState({ waiting: true })

        create({ name, email, access: extendedAccess, team: team ? team : admin.team, password, roleID }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("admin.addedSuccess"), "success")).then(() => {
                    navigate(-1)
                })
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })


    }

    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }

    render = () => {

        const { admin } = this.props
        const { status, name, email, extendedAccess, team, password, roleID, data } = this.state

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("admin.createTitle")}</h1>
                </div>

                <div className="page-form">

                    <div className="form">
                        <div className="form-box">
                            <Input ref={(ref) => this._name = ref} label={t("admin.name")} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                            <Input ref={(ref) => this._email = ref} label="Email" value={email} onChange={(event) => this.setState({ email: event.target.value })} />
                            <select value={roleID} onChange={(event) => this.setState({ roleID: event.target.value })}>
                                <option disabled value={0}>{t("admin.selectRole")}</option>
                                {data.map((item, index) => <option key={`${index}`} value={item.id}>{item.name}</option>)}
                            </select>

                            {
                                admin.isAdmin ?
                                    <div className="extended-access">
                                        <p>{t("admin.extendedAccess")}</p>
                                        <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ extendedAccess: value })} checked={extendedAccess} />
                                    </div>
                                    : null
                            }

                            {admin.isAdmin && extendedAccess ? <Input ref={(ref) => this._command = ref} label={t("admin.teamName")} value={team} onChange={(event) => this.setState({ team: event.target.value })} /> : null}

                            <Input ref={(ref) => this._password = ref} label={t("auth.password")} value={password} onChange={(event) => this.setState({ password: event.target.value })} secure />
                            <div onClick={() => this.setState({ password: utils.generatePassword() })} className="form-generate-password">{t("common.generatePassword")}</div>
                        </div>
                    </div>

                    <div className="form-bottom">
                        {this._button()}
                    </div>

                </div>

            </div>
        )
    }

}


const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        language: state.language,
    }
}

export default connect(mapStateToProps)(withRouter(AdminCreate))